module.exports = function probabilisticSymmetric(a, b) {
    var i = 0,
        ii = a.length,
        d = 0;
    for (; i < ii; i++) {
        d += ((a[i] - b[i]) * (a[i] - b[i])) / (a[i] + b[i]);
    }
    return 2 * d;
};



//////////////////
// WEBPACK FOOTER
// ./~/ml-distance/src/distances/probabilisticSymmetric.js
// module id = 135
// module chunks = 0